module.exports = __webpack_public_path__ + "media/reskin-images/icon--play-circle2-b465ed65.svg";